<div class="empty-list-container">
    <img src="assets/images/empty-state.svg" alt="" />
    <div class="info-text">{{ infoText }}</div>
</div>
